import { Navigate } from 'react-router-dom';
import { useStakeholdersAccess } from '@/hooks/useStakeholdersPermissions';
import { useAdminCheck } from '@/hooks/useAdminCheck';

interface StakeholdersProtectedRouteProps {
  children: React.ReactNode;
}

export const StakeholdersProtectedRoute = ({ children }: StakeholdersProtectedRouteProps) => {
  const { isAdmin, isLoading: isAdminLoading } = useAdminCheck();
  const { data: hasAccess, isLoading } = useStakeholdersAccess();
  
  // Admin override - admins always have access
  if (isAdmin) {
    return <>{children}</>;
  }
  
  if (isLoading || isAdminLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }
  
  if (!hasAccess) {
    return <Navigate to="/" replace />;
  }
  
  return <>{children}</>;
};